import React from "react";
import { Check } from "lucide-react";

/**
 * One selectable profile of a list: checkbox, name, one line of detail and, on the right, an
 * optional slot (positive rating thumb, missions badge). The whole row toggles the choice.
 * The slot sits outside the checkbox button: it may hold its own focusable element (the missions
 * badge and its card), which a button cannot contain.
 */
const ProfileChoice = ({ name, detail, checked, onToggle, aside }) => (
    <div
        className={`flex w-full items-center border-b transition-colors last:border-b-0 ${
            checked ? "bg-yellow-50" : "bg-white hover:bg-gray-50"
        }`}
    >
        <button
            type="button"
            role="checkbox"
            aria-checked={!!checked}
            onClick={onToggle}
            className={`flex min-w-0 flex-1 items-center gap-4 py-4 pl-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-yellow-300 ${
                aside ? "pr-4" : "pr-5"
            }`}
        >
            <span
                aria-hidden="true"
                className={`flex h-5 w-5 shrink-0 items-center justify-center rounded border-2 transition-all ${
                    checked ? "border-yellow-500 bg-yellow-500" : "border-gray-300 bg-white"
                }`}
            >
                {checked ? <Check size={12} strokeWidth={3} color="#FFFFFF" /> : null}
            </span>
            <span className="flex min-w-0 flex-col">
                <span className="ft-b text-gray-900">{name}</span>
                {detail ? <span className="ft-sm text-gray-500 break-words">{detail}</span> : null}
            </span>
        </button>
        {aside ? (
            // A pointer click on the slot toggles the row too; keyboard users toggle with the button.
            <span className="flex shrink-0 cursor-pointer items-center self-stretch pr-5" onClick={onToggle}>
                {aside}
            </span>
        ) : null}
    </div>
);

export default ProfileChoice;
